import { useState, useRef, useEffect } from "react";
import useRetryFetch from "../../hooks/useRetryFetch";
import { config } from "../../Environment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Spinner } from "../ui/spinner";
import { trackRedesignRegistration } from "../../lib/analytics";
import { trackRedesignRegistrationWithData } from "../../lib/appTracking";

const SendEmail = ({ processId, userData = {}, itemkey, content, onChange }) => {
  const [isLoading, setIsLoading] = useState(false);

    const sendEmail = async () => {
      try {
        setIsLoading(true);
        const response = await retryFetch(
          `${config.API_BASE}/api/process/${processId}/component/send-email`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              userData,
            }),
          }
        );
        if (response.ok) {
          const data = await response.json();
          onChange(content.key, 1); // just set a value of 1 to indicate email was sent

          // Check if this is the redesign service workflow
          const urlParams = new URLSearchParams(window.location.search);
          const prescriptionID = urlParams.get("wid");
          const REDESIGN_WORKFLOW_ID = "684674c25b8616607de70951";
          
          if (prescriptionID === REDESIGN_WORKFLOW_ID) {
            // Track redesign service registration
            // GA4 - privacy-safe (no personal data)
            trackRedesignRegistration();

            // Internal tracking - with full form data
            trackRedesignRegistrationWithData({
              workflowId: prescriptionID,
              processId: processId,
              userData: userData,
            });
          }
        }
      } catch (err) {
        console.log(`Send email failed: ${err.message}`);
      } finally {
        setIsLoading(false);
      }
    };

  const retryFetch = useRetryFetch();
  useEffect(() => {
    sendEmail();
  }, []);

  return (
    <div className="mt-5 text-start">
      {isLoading ? (
        <Spinner size="md" />
      ) : (
        ""
      )}
    </div>
  );
};

export default SendEmail;
